import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@services/session';

export const NoAuthGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (!sessionService.isAuthenticated()) {
    return true; //* Usuario no autenticado, puede navegar.
  }

  router.navigate(['perfil', 'admin']); //* Redirigir al área autenticada.
  document.documentElement.scrollTop = 0;
  return false; //* Bloquear navegación.
};
